import React from "react";
import { Box } from "@mui/material";
import "./styles.scss";
import { WelcomeMilesBubbleProps } from "./types";
import useProductSpecificProperties from "../useProductSpecificProperties";

const classNameBase = "scd-product-choice";

export default function WelcomeMilesBubble({
  label,
  product,
}: WelcomeMilesBubbleProps): React.JSX.Element {
  const { getMilesAndMore } = useProductSpecificProperties();
  const miles = getMilesAndMore(product);
  return (
    <Box className={`${classNameBase}`}>
      <span className={`${classNameBase}-label`}>{label}</span>
      <span className={`${classNameBase}-miles-label`}>{miles}</span>
    </Box>
  );
}
